import {BreadcrumbV1} from '@volkswagen-onehub/breadcrumb-service';
import {
  CTA,
  Text,
  TextAppearance,
  TextColor,
  TextTag,
  styled,
} from '@ngw6/us-components';
import React from 'react';
import {createClickHandler} from './create-click-handler';

export interface BreadcrumbBarProps {
  readonly breadcrumbs: BreadcrumbV1[];
}

const StyledWrapper = styled.div`
  display: flex;
  align-items: center;
  min-height: ${(props) => props.theme.size.static300};
`;

const ChevronWrapper = styled.div`
  font-size: 6px;
  color: ${(props) => props.theme.interaction.recipe150?.checked};
  padding: 0 ${(props) => props.theme.size.static150};
`;

export function BreadcrumbBar({breadcrumbs}: BreadcrumbBarProps): JSX.Element {
  return (
    <StyledWrapper>
      {breadcrumbs.map((breadcrumb, index) => (
        <React.Fragment key={breadcrumb.href}>
          {index === breadcrumbs.length - 1 ? (
            <Text
              tag={TextTag.span}
              staticSize
              appearance={TextAppearance.label150}
              bold
            >
              {breadcrumb.label}
            </Text>
          ) : (
            <>
              <CTA
                tag="a"
                emphasis="tertiary"
                onClick={createClickHandler(breadcrumb.onClick)}
                href={breadcrumb.href}
              >
                <Text
                  tag={TextTag.span}
                  staticSize
                  appearance={TextAppearance.label150}
                  color={TextColor.inherit}
                >
                  {breadcrumb.label}
                </Text>
              </CTA>
              <ChevronWrapper>&#9654;</ChevronWrapper>
            </>
          )}
        </React.Fragment>
      ))}
    </StyledWrapper>
  );
}
